module.exports = __webpack_public_path__ + "img/icon-warning-drivingconditions-orange.a2000c4f.svg";